export default __webpack_public_path__ + "static/media/renouvellement.41fa13f4.png";